class TasacionesFunnelManager {
    constructor(stepConfig) {
        this.stepConfig = stepConfig;
        this.currentStep = stepConfig.stepNumber;
        this.formData = new Map();
        this.apiClient = new TasacionesApiClient();
        // this.analytics = new TasacionesAnalytics();
        
        this.init();
    }

    init() {
        if (!this.validateEnvironment()) return;
        
        // this.analytics.trackStepView(this.currentStep);
    }

    validateEnvironment() {
        const requiredForm = document.getElementById(`tasaciones-funnel-step-${this.currentStep}`);
        return requiredForm && typeof TasacionesConf !== 'undefined';
    }
    
    // Método base que debe ser sobrescrito por las clases hijas
    bindEvents() {
        // Implementación vacía por defecto
        // Las clases hijas deben sobrescribir este método
    }

    loadInitialData() {
        // Implementación vacía por defecto
        // Las clases hijas pueden sobrescribir este método si necesitan cargar datos iniciales
    }

    showError(message) {
        // Implementación básica, puedes mejorarla
        console.error('Step Error:', message);
        // alert(message);
    }

    showLoading(show) {
        // Implementación básica, puedes mejorarla
        const loadingElement = document.getElementById('loading-indicator');
        if (loadingElement) {
            loadingElement.style.display = show ? 'flex' : 'none';
        }
        console.log('Loading:', show);
    }

    showAddressLoading(show) {
        // Implementación básica, puedes mejorarla
        const loadingElement = document.getElementById('loading-address-indicator');
        if (loadingElement) {
            loadingElement.style.display = show ? 'flex' : 'none';
        }
        console.log('Loading:', show);
    }

    isLoading(){
        const loadingElement1 = document.getElementById('loading-indicator');
        if (loadingElement1) {
            if (loadingElement1.style.display === 'flex') return true;
        }
        const loadingElement2 = document.getElementById('loading-address-indicator');
        if (loadingElement2) {
            if (loadingElement2.style.display === 'flex') return true;
        }
        return false;
    }

    showMessage(message, type = 'info') {
        // Implementación básica, puedes mejorarla
        console.log(`${type.toUpperCase()}: ${message}`);
    }
}

// Hacer la clase disponible globalmente
window.TasacionesFunnelManager = TasacionesFunnelManager;